import React, { useState } from 'react';
import { useUnits } from '../../context/unitsContext';
import { toast } from 'react-toastify';
import useSubmitLock from '../../utils/useSubmitLock';

function RegisterCell({ onCloseModal, onSaveSuccess, pavilionId, typeCell, destination }) {
  const { saveCell } = useUnits();
  const toNumberOrEmpty = (value) => {
    if (value === '' || value === null || value === undefined) {
      return '';
    }
    const asNumber = Number(value);
    return Number.isNaN(asNumber) ? value : asNumber;
  };

  const [cellData, setCellData] = useState({
    name: '',
    capacity: '',
    order: '',
    bathroom: false,
    bathroom_use: false,
    type_cell: '',
    destination: '',
    pavilion: toNumberOrEmpty(pavilionId)
  });
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCellData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        const payload = {
          ...cellData,
          capacity: toNumberOrEmpty(cellData.capacity),
          order: toNumberOrEmpty(cellData.order),
          type_cell: toNumberOrEmpty(cellData.type_cell),
          destination: toNumberOrEmpty(cellData.destination),
          pavilion: toNumberOrEmpty(cellData.pavilion),
        };

        await saveCell(payload);
        onSaveSuccess?.(pavilionId);
        onCloseModal();
      } catch (error) {
        console.error('Erro ao cadastrar a cela:', error);
        toast.error('Erro ao cadastrar a cela');
      }
    });
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="unit-modal-form unit-modal-grid">
        <div className="unit-modal-field">
          <label>Nome</label>
          <input
            maxLength={10}
            type="text"
            name="name"
            value={cellData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="unit-modal-field">
          <label>Capacidade</label>
          <input
            type="number"
            name="capacity"
            min="1"
            value={cellData.capacity}
            onChange={handleChange}
            required
          />
        </div>

        <div className="unit-modal-field">
          <label>Ordem</label>
          <input
            type="number"
            name="order"
            min="1"
            value={cellData.order}
            onChange={handleChange}
            required
          />
          <small className='field-hint'>Ordem de visualização da cela</small>
        </div>

        <div className="unit-modal-field">
          <label>Tipo de Cela</label>
          <select
            name="type_cell"
            onChange={handleChange}
            value={cellData.type_cell}
            required
          >
            <option value="">Selecione o tipo de cela</option>
            {typeCell && typeCell && typeCell.map((type) => (
              <option key={type.id} value={type.id}>{type.type}</option>
            ))}
          </select>
        </div>

        <div className="unit-modal-field">
          <label>Destino</label>
          <select
            name="destination"
            onChange={handleChange}
            value={cellData.destination}
            required
          >
            <option value="">Selecione o destino</option>
            {destination && destination && destination.map((dest) => (
              <option key={dest.id} value={dest.id}>{dest.name}</option>
            ))}
          </select>
        </div>

        <div className="unit-modal-field">
          <label>Possui banheiro?</label>
          <input
            type="checkbox"
            name="bathroom"
            checked={cellData.bathroom}
            onChange={handleChange}
          />
        </div>

        <div className="unit-modal-field">
          <label>Banheiro em Uso?</label>
          <input
            type="checkbox"
            name="bathroom_use"
            checked={cellData.bathroom_use}
            onChange={handleChange}
          />
        </div>

        <div className="unit-modal-actions">
          <button type="submit" className="btnConfirmar" disabled={isSubmitting}>
            {isSubmitting ? 'Adicionando...' : 'Adicionar'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default RegisterCell;
